import {
    Component,
    OnInit,
    Input,
    ViewChild,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import { CertificationVariantVersionInterface } from 'src/app/model/certifications/certification-variant-version-interface';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { DataType } from 'src/app/model/data-type.enum';
import { NgForm, NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PtgVersionInterface } from 'src/app/model/ptgs/ptg-version-interface';
import { AttributeInterface } from 'src/app/model/attributes/attribute-interface';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { CertificationInterface } from 'src/app/model/certifications/certification-interface';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { CertificationVariantInterface } from 'src/app/model/certifications/certification-variant-interface';
import { ValidationInterface } from 'src/app/model/attributes/validation-interface';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { MatSelectChange } from '@angular/material/select';
import { ProductVariantService } from 'src/app/services/dataServices/product-variant-service/product-variant.service';
import { CertificationVariantService } from 'src/app/services/dataServices/certification-variant-service/certification-variant-service';
import { ProductVariantVersionService } from 'src/app/services/dataServices/product-variant-version-service/product-variant-version.service';
import { CertificationVariantVersionService } from 'src/app/services/dataServices/cetrification-variant-version-service/certification-variant-version-service';
import { Status } from 'src/app/model/enums/status';
import { UtilService } from 'src/app/services/util-service/utilService';
import { MinLengthErrorStateMatcher } from "src/environments/validators";


@Component({
    selector: 'app-version-edit',
    templateUrl: './version-edit.component.html',
    styleUrls: ['./version-edit.component.scss'],
    standalone: false
})
export class VersionEditComponent implements OnInit, OnDestroy {
    @Input()
    set version(value: VariantVersionInterface | CertificationVariantVersionInterface) {
        this._version = value;
        if (!this._version.status) this._version.status = Status.ACTIVE;
    }
    @Input() product?: ProductInterface;
    @Input() dataType: DataType;
    @Input() isCreateNew: boolean;
    @Input() selectedCategory?: string;
    @Output() validityChanged = new EventEmitter<boolean>();
    @ViewChild('form') ngForm: NgForm;
    private _version!: VariantVersionInterface | CertificationVariantVersionInterface;
    @ViewChild('versionNameCtrl') versionNameCtrl!: NgModel;
    private formValid: boolean = false;
    private descriptionValid: boolean = true;
    private formSubscription: Subscription;
    private showFeatureCatalogue: boolean;
    Status = Status;

    get version() {
        return this._version;
    }

    public catalogueAttributes: AttributeInterface[] = [];
    private optionalPtgAttributes: AttributeInterface[] = [];
    private ptgAttributes: AttributeInterface[] = [];
    public isCertification: boolean = false;
    private addOtherVersionAttributesMode: boolean = false;
    private allVersionsOfActiveVariant:
        | CertificationVariantVersionInterface[]
        | VariantVersionInterface[];
    private selectedDependeeVariant:
        | CertificationVariantInterface
        | ProductVariantInterface;
    private selectedDependeeVersion:
        | CertificationVariantVersionInterface
        | VariantVersionInterface;

    versionNameErrorStateMatcher = new MinLengthErrorStateMatcher(160);

    constructor(
        private productService: ProductService,
        private productVariantService: ProductVariantService,
        private productVariantVersionService: ProductVariantVersionService,
        private certificationService: CertificationService,
        private certificationVariantService: CertificationVariantService,
        private certificicationVariantVersionService: CertificationVariantVersionService,
        private attributeValidationService: AttributeValidationServiceService,
        private dialogService: DialogService,
        public utilService: UtilService
    ) { }

    ngOnDestroy() {
        if (this.formSubscription != null) {
            this.formSubscription.unsubscribe();
        }
    }

    ngOnInit() {
        this.isCertification = this.dataType
            .includes('CERTIFICATION');
        this.attributeValidationService.reset();
        this.setInitialVariableValues();
    }

    ngAfterViewInit() {
        this.setUpFormSubscription();
    }

    private setUpFormSubscription() {
        this.formSubscription = this.ngForm.valueChanges.subscribe(() => {
            this.formValid = this.ngForm.valid;
            this.checkCurrentValidity();
        });
    }

    private setInitialVariableValues(): void {
        this.version.ptgVersions = [];
        this.version.ptgVersionIds = [];
        this.version.keywords = [];
        this.version.status = Status.ACTIVE;
        this.version.description = '';
        if (this.isVersionEditMode()) {
            this.allVersionsOfActiveVariant =
                this.getAllVersionsOfActiveVariant();
            if (this.version.id != null) {
                let currentVersion:
                    | CertificationVariantVersionInterface
                    | VariantVersionInterface;
                if (this.isCertification) {
                    currentVersion =
                        this.certificicationVariantVersionService.activeItem;
                } else {
                    currentVersion =
                        this.productVariantVersionService.activeItem;
                }
                this.version.status = currentVersion.status;
                this.version.name = currentVersion.name;
                this.version.comment = currentVersion.comment;
                this.version.description = currentVersion.description;
                this.version.keywords = currentVersion.keywords;
                this.addAttributeValidationsFromOtherVersion(this.version.id);
                if (currentVersion.attributeValidationValues && currentVersion.attributeValidationValues.length > 0) {
                    this.attributeValidationService.loadSavedAttributeValues(currentVersion.attributeValidationValues);
                }
                this.version.previousVersion = currentVersion.previousVersion;
                this.selectedDependeeVersion = null;
            } else if (this.version.previousVersion != null) {
                this.addAttributeValidationsFromOtherVersion(
                    this.version.previousVersion
                );
            }
            this.selectedDependeeVariant = null;
        }
    }

    public isCertificationEditMode() {
        return this.dataType.includes('CERTIFICATION');
    }

    public isVersionEditMode() {
        return this.dataType.includes('VERSION');
    }

    private getAllVersionsOfActiveVariant():
        | CertificationVariantVersionInterface[]
        | VariantVersionInterface[] {
        let allVersionsOfActiveVariant = [];
        let activeVariant;
        if (this.isCertification) {
            activeVariant = this.certificationVariantService.activeItem;
            allVersionsOfActiveVariant =
                activeVariant.certificationVariantVersions.filter(
                    (version) => version.id != this.version.id
                );
        } else {
            activeVariant = this.productVariantService.activeItem;
            allVersionsOfActiveVariant = activeVariant.variantVersions.filter(
                (version) => version.id != this.version.id
            );
        }
        this.selectedDependeeVariant = activeVariant;
        return allVersionsOfActiveVariant;
    }

    private setEffectiveAttributeValidations(): void {
        this.attributeValidationService.setEffectiveAttributeValidations(
            this.catalogueAttributes,
            this.ptgAttributes,
            this.optionalPtgAttributes
        );
    }

    private setAttributeValidationValuesFromStringValues(attributeValidation: {
        attribute: AttributeInterface;
        value: string;
    }) {
        const attribute: AttributeInterface = attributeValidation.attribute;
        const validationValue: string = attributeValidation.value;
        const value = this.parseAttributeValueFromString(
            attribute.datatype,
            validationValue
        );
        const validation = attribute.validations[0];
        this.attributeValidationService.modelChangedValid(
            attribute,
            validation,
            value
        );
    }

    // Helper method that Parses the value of an attribute depending on its datatype
    private parseAttributeValueFromString(
        dataType: string,
        validationValue: string
    ) {
        if (validationValue == null) {
            return null;
        }
        let result: any;
        switch (dataType) {
            case 'NUMERIC': {
                result = parseInt(validationValue);
                if (isNaN(result)) {
                    result = null;
                }
                break;
            }
            case 'BOOLEAN': {
                result =
                    validationValue === 'undefined'
                        ? null
                        : validationValue === 'true';
                break;
            }
            case 'LIST': {
                result = validationValue.split(';');
                break;
            }
            default: {
                result = validationValue;
            }
        }
        return result;
    }

    // data flow method for component input of attribute validation table
    private getOptionalAttributesOfPtgVersion(
        ptgVersion: PtgVersionInterface
    ): AttributeInterface[] {
        const attributes: AttributeInterface[] = [];
        const ptgAttributeValidations = ptgVersion.attributeValidations;
        for (const ptgAttributeValidation of ptgAttributeValidations) {
            if (ptgAttributeValidation.optionalValidation) {
                const attribute = ptgAttributeValidation.attribute;
                attributes.push(attribute);
            }
        }
        return attributes;
    }

    // data flow method for component input of attribute validation table
    private getNonOptionalAttributesOfPtgVersion(
        ptgVersion: PtgVersionInterface
    ): AttributeInterface[] {
        const attributes: AttributeInterface[] = [];
        const ptgAttributeValidations = ptgVersion.attributeValidations;
        for (const ptgAttributeValidation of ptgAttributeValidations) {
            if (!ptgAttributeValidation.optionalValidation) {
                const attribute = ptgAttributeValidation.attribute;
                attributes.push(attribute);
            }
        }
        return attributes;
    }

    getPtgName(version: PtgVersionInterface): string {
        return version.ptgName;
    }

    // Event listener for the attribute validation table
    public onAttributesChanged(attributes: AttributeInterface[]): void {
        this.checkCurrentValidity();

        // TODO: Check functionality for Certifications. Now only implemented for products. Therefor the code below is commented out. It needs to be checked if it works for certifications as well or if adjustments are necessary.
        // this.catalogueAttributes = attributes;
        // this.setEffectiveAttributeValidations();
    }

    // event listener for add-ptg component
    public onPtgVersionAdded(ptgVersion: PtgVersionInterface): void {
        const attributeValidations = ptgVersion.attributeValidations;
        for (const attributeValidation of attributeValidations) {
            const attribute = attributeValidation.attribute;
            if (attributeValidation.optionalValidation) {
                // Adds attribute array with optionalPtgAttributes array
                this.optionalPtgAttributes =
                    this.optionalPtgAttributes.concat(attribute);
            } else {
                // Adds attribute array with ptgAttributes array
                this.ptgAttributes = this.ptgAttributes.concat(attribute);
            }
        }
        // hier noch mal ran. attrubutes werden nur addiert. Nicht aber gelöscht beim removen
        this.setEffectiveAttributeValidations();
        this.checkCurrentValidity();
    }

    // event listener for add-ptg component
    public onPtgVersionRemoved(removedVersion: PtgVersionInterface): void {
        this.version.ptgVersions = this.version.ptgVersions.filter(v => v.id !== removedVersion.id);
        this.version.ptgVersionIds = this.version.ptgVersionIds.filter(id => id !== removedVersion.id);
        this.checkCurrentValidity();
    }

    // Event listener for the add-ptg-component
    public onPtgVersionsChanged(ptgVersions: PtgVersionInterface[]): void {
        this.ptgAttributes = [];
        this.optionalPtgAttributes = [];
        this.setPtgAttributeArrays(ptgVersions);
        this.setEffectiveAttributeValidations();
        this.checkCurrentValidity();
    }

    private setPtgAttributeArrays(ptgVersions: PtgVersionInterface[]): void {
        for (const ptgVersion of ptgVersions) {
            for (const ptgAttributeValidation of ptgVersion.attributeValidations) {
                const attribute = ptgAttributeValidation.attribute;
                if (ptgAttributeValidation.optionalValidation) {
                    this.optionalPtgAttributes =
                        this.optionalPtgAttributes.concat(attribute);
                } else {
                    this.ptgAttributes = this.ptgAttributes.concat(attribute);
                }
            }
        }
    }

    private showFeatureCatalogueToggle(): void {
        this.showFeatureCatalogue = !this.showFeatureCatalogue;
    }

    // Handles the data flow from the version to the Feature-Catalogue
    public featureCatalogueConfirmPressed(
        attributes: AttributeInterface[]
    ): void {
        for (const newAttribute of attributes) {
            this.addNewAttribute(newAttribute);
        }
        this.setEffectiveAttributeValidations();
        this.showFeatureCatalogueToggle();
    }

    // Adds a new attribute to the current attributes of the version
    // Checks for duplicates.
    private addNewAttribute(newAttribute: AttributeInterface): void {
        const existingAttributes = this.catalogueAttributes.concat(
            this.ptgAttributes,
            this.optionalPtgAttributes
        );
        const existingAttrbutesWithSameId = existingAttributes.filter(
            (existingAttribute) => {
                return existingAttribute.id === newAttribute.id;
            }
        );
        for (const existingAttribute of existingAttrbutesWithSameId) {
            const containsSameValidation =
                this.checkIfAttributesContainSameValidation(
                    existingAttribute,
                    newAttribute
                );
            if (containsSameValidation) {
                this.dialogService.openDialog(
                    'Merkmal hinzufügen fehlgeschlagen',
                    'Die gewählte Validierung für das Merkmal ' +
                    newAttribute.name +
                    ' ist bereits vorhanden. Bitte wählen sie eine andere Validierung oder ein anderes Merkmal'
                );
                return;
            }
        }
        this.attributeValidationService.activeEntityFeatureValues.set(
            newAttribute.id,
            undefined
        );
        this.attributeValidationService.attributesValidated.set(
            newAttribute.id,
            false
        );
        this.catalogueAttributes.push(newAttribute);
        existingAttributes.push(newAttribute);
    }

    private checkIfAttributesContainSameValidation(
        attribute1: AttributeInterface,
        attribute2: AttributeInterface
    ): boolean {
        const validation1 = attribute1.validations[0];
        const validation2 = attribute2.validations[0];
        return validation1.id === validation2.id;
    }

    public isVariantCreateMode() {
        return this.dataType.includes('VARIANT');
    }

    addOtherVersionAttributesModeToggle(value: boolean): void {
        this.addOtherVersionAttributesMode = value;
    }

    private getOtherVariantsOfEntity():
        | CertificationVariantInterface[]
        | ProductVariantInterface[] {
        if (this.isCertification) {
            return this.certificationService.activeItem.certificationVariants;
        } else {
            return this.productService.activeItem.productVariants;
        }
    }

    private setDependeeVariant(event: MatSelectChange): void {
        let variantId: number = parseInt(event.value);
        if (this.isCertification) {
            let currentCertification: CertificationInterface =
                this.certificationService.activeItem;
            this.selectedDependeeVariant =
                currentCertification.certificationVariants.find(
                    (variant: CertificationVariantInterface) =>
                        variant.id === variantId
                );
        } else {
            let currentProduct: ProductInterface =
                this.productService.activeItem;
            this.selectedDependeeVariant = currentProduct.productVariants.find(
                (variant: ProductVariantInterface) => variant.id === variantId
            );
        }
    }

    private filterSelectedVariant(
        selectedVariantId: string,
        selected: boolean
    ): CertificationVariantVersionInterface[] | VariantVersionInterface[] {
        let variants = this.getOtherVariantsOfEntity();
        try {
            if (!selected) {
                if (this.isCertification) {
                    const tempVariants: CertificationVariantInterface[] =
                        variants;
                    return tempVariants.filter(
                        (variant: CertificationVariantInterface) =>
                            variant.id === parseInt(selectedVariantId)
                    )[0].certificationVariantVersions;
                } else {
                    const tempVariants: ProductVariantInterface[] = variants;
                    return tempVariants.filter(
                        (variant: ProductVariantInterface) =>
                            variant.id === parseInt(selectedVariantId)
                    )[0].variantVersions;
                }
            }
        } catch (e) { }
    }

    // listener method
    // Gets PTGs and Attributes from another version(previous version) and sets them in the current version to be created
    public onAddAttributeValidationsFromOtherVersion(
        event: MatSelectChange
    ): void {
        if (this.selectedDependeeVersion != null) {
            this.removePreviousVersion();
        }
        let versionId: number = parseInt(event.value);
        this.addAttributeValidationsFromOtherVersion(versionId);
    }

    private addAttributeValidationsFromOtherVersion(versionId: number): void {
        let selectedVersion;
        selectedVersion = this.getSelectedVersion(versionId);
        let newPtgValidations: number[] = this.addPtgVersionFromOtherVersion(
            selectedVersion.ptgVersions
        );
        const attributeValidationValues: {
            attribute: AttributeInterface;
            value: string;
        }[] = selectedVersion.attributeValidationValues;
        this.addVersionAttributesFromOtherVersion(
            attributeValidationValues,
            newPtgValidations
        );
        this.setEffectiveAttributeValidations();
        for (const attributeValidationValue of attributeValidationValues) {
            this.setAttributeValidationValuesFromStringValues(
                attributeValidationValue
            );
        }
        this.selectedDependeeVersion = selectedVersion;
    }

    private getSelectedVersion(
        versionId: number
    ): CertificationVariantVersionInterface | VariantVersionInterface {
        let selectedVersion;
        if (this.isCertification) {
            const tempVariant: CertificationVariantInterface =
                this.selectedDependeeVariant;
            selectedVersion = tempVariant.certificationVariantVersions.find(
                (version: CertificationVariantVersionInterface) =>
                    versionId === version.id
            );
        } else {
            const tempVariant: ProductVariantInterface =
                this.selectedDependeeVariant;
            selectedVersion = tempVariant.variantVersions.find(
                (version: VariantVersionInterface) => versionId === version.id
            );
        }
        return selectedVersion;
    }

    private addPtgVersionFromOtherVersion(
        newPtgVersions: PtgVersionInterface[]
    ): number[] {
        let newPtgValidations: number[] = [];
        const ptgsToAdd = newPtgVersions.slice(0, 3 - this.version.ptgVersions.length);

        for (const ptgVersion of ptgsToAdd) {
            const attributeValidations = ptgVersion.attributeValidations;
            for (const attributeValidation of attributeValidations) {
                const attribute = attributeValidation.attribute;
                const validation = attribute.validations[0];
                newPtgValidations.push(validation.id);
            }
            const isPtgVersionDuplicate = this.version.ptgVersions.some(
                (existingPtgVersion) => {
                    return existingPtgVersion.id === ptgVersion.id;
                }
            );
            if (!isPtgVersionDuplicate) {
                this.version.ptgVersions.push(ptgVersion);
                this.version.ptgVersionIds.push(ptgVersion.id);
                this.onPtgVersionAdded(ptgVersion);
            }
        }
        return newPtgValidations;
    }

    private addVersionAttributesFromOtherVersion(
        attributeValidationValues: {
            attribute: AttributeInterface;
            value: string;
        }[],
        validationIdsFromPtgs: number[]
    ) {
        for (const attributeValidationValue of attributeValidationValues) {
            const attribute: AttributeInterface =
                attributeValidationValue.attribute;
            const validation: ValidationInterface = attribute.validations[0];
            if (validationIdsFromPtgs.indexOf(validation.id) === -1) {
                this.addNewAttribute(attribute);
            }
        }
    }

    // removes dependency on previous version from subversion.
    // removes PTGS and individual Attributes of the previous version
    private removePreviousVersion(): void {
        this.removePtgsOfPreviousVersion(this.selectedDependeeVersion);

        this.removeVersionAttributesOfPreviousVersion(
            this.selectedDependeeVersion
        );
    }

    // removes ptgs of the previous version on removePreviousVersion call
    private removePtgsOfPreviousVersion(
        previousVersion:
            | CertificationVariantVersionInterface
            | VariantVersionInterface
    ): void {
        for (const previousPtgVersion of previousVersion.ptgVersions) {
            this.version.ptgVersions = this.version.ptgVersions.filter(
                (ptgVersion) => {
                    return ptgVersion.id !== previousPtgVersion.id;
                }
            );
        }
        this.onPtgVersionsChanged(this.version.ptgVersions);
    }

    // removes attributes of the previous version on removePreviousVersion call
    private removeVersionAttributesOfPreviousVersion(
        previousVersion:
            | CertificationVariantVersionInterface
            | VariantVersionInterface
    ) {
        const prevVersionAttributeValues: {
            attribute: AttributeInterface;
            value: string;
        }[] = previousVersion.attributeValidationValues;
        for (const attributeValue of prevVersionAttributeValues) {
            const prevAttribute = attributeValue.attribute;
            this.catalogueAttributes = this.catalogueAttributes.filter(
                (attribute) => {
                    return !this.checkIfAttributesContainSameValidation(
                        attribute,
                        prevAttribute
                    );
                }
            );
        }
        this.onAttributesChanged(this.catalogueAttributes);
    }

    public onDescriptionValidityChange(descriptionValid: boolean): void {
        if (this.descriptionValid != descriptionValid) {
            this.descriptionValid = descriptionValid;
            this.checkCurrentValidity();
        }
    }

    private checkCurrentValidity(): void {
        if (this.isCertification) {
            this.checkCertOverallValidity();
            return;
        }
        this.checkOverallValidity();
    }

    private checkOverallValidity(): void {
        const hasPtgSelected = this.version.ptgVersions && this.version.ptgVersions.length > 0;
        const versionName = this.versionNameCtrl?.value ?? '';
        const isVersionNameValid = versionName.length > 0 && versionName.length <= 160;

        const allPtgsHaveAtLeastOneAttribute = hasPtgSelected &&
            this.version.ptgVersions.every(ptgVersion => {
                const attributeValidations = ptgVersion.attributeValidations ?? [];
                return attributeValidations.some(validation =>
                    this.attributeValidationService.activeEntityFeatureValues.get(validation.attribute.id) === 'true'
                );
            });

        let isValid: boolean;
        if (this.isCertificationEditMode()) isValid = this.checkCertOverallValidity();
        else if (!this.isCertificationEditMode() && (this.isVersionEditMode() || this.isVariantCreateMode()))
            isValid = this.formValid && this.descriptionValid && hasPtgSelected;
        else isValid = this.formValid && this.descriptionValid && isVersionNameValid && allPtgsHaveAtLeastOneAttribute;
        this.validityChanged.emit(isValid);
    }

    private checkCertOverallValidity(): boolean {
        const versionName = this.versionNameCtrl?.value ?? '';
        const isVersionNameValid = versionName.length > 0 && versionName.length <= 160;

        const isValid = this.formValid &&
            this.descriptionValid &&
            isVersionNameValid;

        this.validityChanged.emit(isValid);
        return isValid;
    }

    moveUp(index: number): void {
        if (index > 0) {
            // resort ptgVersions
            const tempVersion = this.version.ptgVersions[index];
            this.version.ptgVersions[index] = this.version.ptgVersions[index - 1];
            this.version.ptgVersions[index - 1] = tempVersion;

            // resort ptgVersionIds
            const tempId = this.version.ptgVersionIds[index];
            this.version.ptgVersionIds[index] = this.version.ptgVersionIds[index - 1];
            this.version.ptgVersionIds[index - 1] = tempId;

            this.updatePtgVersionOrderInDescriptions();

            // trigger change detection
            this.version.ptgVersions = [...this.version.ptgVersions];
            this.version.ptgVersionIds = [...this.version.ptgVersionIds];
        }
    }

    moveDown(index: number): void {
        if (index < this.version.ptgVersions.length - 1) {
            // resort ptgVersions
            const tempVersion = this.version.ptgVersions[index];
            this.version.ptgVersions[index] = this.version.ptgVersions[index + 1];
            this.version.ptgVersions[index + 1] = tempVersion;

            // resort ptgVersionIds
            const tempId = this.version.ptgVersionIds[index];
            this.version.ptgVersionIds[index] = this.version.ptgVersionIds[index + 1];
            this.version.ptgVersionIds[index + 1] = tempId;

            this.updatePtgVersionOrderInDescriptions();

            // trigger change detection
            this.version.ptgVersions = [...this.version.ptgVersions];
            this.version.ptgVersionIds = [...this.version.ptgVersionIds];
        }
    }

    canMoveUp(index: number): boolean {
        return index > 0;
    }

    canMoveDown(index: number): boolean {
        return index < this.version.ptgVersions.length - 1;
    }

    private updatePtgVersionOrderInDescriptions(): void {
        this.version.ptgVersions.forEach((v, i) => {
            v.description = v.description?.replace(/\s*<<>>\d+,\d+$/, '') || '';
            v.description = `${v.description}<<>>${v.id},${i + 1}`;
        });
    }
}
